<div class="loader">
  <div class="loader-top-bar">
    <h2>{{ message| translate }}</h2>
  </div>
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
